import { render, staticRenderFns } from "./PlayerSetting.vue?vue&type=template&id=605cec78&scoped=true"
import script from "./PlayerSetting.vue?vue&type=script&lang=js"
export * from "./PlayerSetting.vue?vue&type=script&lang=js"
import style0 from "./PlayerSetting.vue?vue&type=style&index=0&id=605cec78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cec78",
  null
  
)

export default component.exports